import {omit, difference, keys, keyBy, createReducer, map, filter, find} from 'helpers';

export const listItems = createReducer({}, {

  LIST_ITEM_UPDATE: (state, { listItem }) => ({
    ...state,
    [listItem.id]: {
      ...state[listItem.id],
      ...listItem,
    }
  }),

  LIST_ITEMS_UPDATE: (state, { list, generateId, select }) => {
    if (list.items) {
      const current = map(list.items, (item, index) => ({
        ...item,
        listId: list.id || generateId('listId'),
      }));
      const before = select('lists.details', { id: list.id || generateId('id') }) || {};
      const removed = filter(before.items, item => !find(current, { id: item.id }));
      if (current.length || removed.length) {
        return {
          ...omit(state, map(removed, 'id')),
          ...keyBy(current, 'id'),
        }
      }
    }
    return state;
  },

  LIST_ITEM_TOGGLE: (state, { id }) => {
    return {
      ...state,
      [id]: {
        ...state[id],
        status: state[id]?.status === 'Completed' ? 'none' : 'Completed',
      }
    }
  },

  SERVER_DATA_RECEIVED: (state, action) => {
    const removed = difference(keys(state), action.existingElementIds.listItems);
    if (action.listItems.length || removed.length) {
      return omit({
        ...state,
        ...keyBy(action.listItems, 'id'),
      }, removed);
    }
    return state;
  },

  TESTING_DELETE_ALL: () => ({}),

});
